import Selectable from './selectable.js'
import Sortable from 'sortablejs';
import ControlBarHandlers from './control-bar-handlers.js'
import UIUtils from './ui-utils.js'

let selectedFolders = [];
let selectedFiles = [];

export function initGrids() {

    const grids = document.querySelectorAll('.selectable');
    const foldersGrid = document.querySelector('.selectable:not(.artworks-list)');
    const filesGrid = document.querySelector('.selectable.artworks-list');

    let controlBarHandlers = new ControlBarHandlers();

    // Ensure the filter button works even when no grids are present
    const filterArtBrowserButton = document.querySelector('.breadcrumb.browse .btn-filter');
    if (filterArtBrowserButton) {
        filterArtBrowserButton.addEventListener('click', () => {
            controlBarHandlers.handleBrowseFilter();
        });
    }

    const filterCategoryButton = document.querySelector('.breadcrumb.categories .btn-filter');
    if (filterCategoryButton) {
        filterCategoryButton.addEventListener('click', () => {
            controlBarHandlers.handleCategoryFilter();
        });
    }

    const filterPagesButton = document.querySelector('.breadcrumb.pages .btn-filter');
    if (filterPagesButton) {
        filterPagesButton.addEventListener('click', () => {
            controlBarHandlers.handlePagesFilter();
        });
    }

    //

    if (!grids.length) {

        return;
    }

    const updateControlsBar = () => {

        const controlsBar = document.querySelector('.controls-bar');
        const selectedCountSpan = document.querySelector('#selected-count');
        const selectedCount = selectedFolders.length + selectedFiles.length;

        const combinedSelectedItems = [...selectedFolders, ...selectedFiles];

        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tif'];

        const allItemsAreImages = combinedSelectedItems.every(item => {
            const extension = item.getAttribute('data-ext').toLowerCase();
            return imageExtensions.includes(extension);
        });

        const hasSystemItems = combinedSelectedItems.some(item => item.getAttribute('data-tags') === 'system');

        if (selectedCountSpan) {
            selectedCountSpan.textContent = selectedCount.toLocaleString();
        }

        if (controlsBar) {
            if (selectedCount > 0 && !hasSystemItems) {
                controlsBar.classList.remove('hidden');
                controlBarHandlers.updateSelectedItems(combinedSelectedItems);
            } else {
                controlsBar.classList.add('hidden');
            }
        }
    };

    const handleSelectionChange = (event, selectedArray) => {
        const selectedItems = event.detail.selectedItems;
        selectedArray.splice(0, selectedArray.length, ...selectedItems);
        updateControlsBar();
    };

    grids.forEach(grid => {

        new Selectable(grid, '.item');

        grid.addEventListener('selectionChanged', (event) => {
            if (grid === foldersGrid) {
                handleSelectionChange(event, selectedFolders);
            } else if (grid === filesGrid) {
                handleSelectionChange(event, selectedFiles);
            }
        });

        if (grid.classList.contains('draggable')) {
            Sortable.create(grid, {
                handle: '.cursor-move', // Restricts sort start click to the drag handle element
                animation: 150,
                onEnd: function (evt) {
                    const itemEl = evt.item;
                    const orderedIds = Array.from(grid.children).map(item => item.dataset.id);
                    console.log('New order:', orderedIds);

                    postNewOrder(orderedIds);
                },
            });
        }
    });

    async function postNewOrder(orderedIds) {
        try {
            const response = await fetch('/api/category/update-order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ orderedIds: orderedIds })
            });

            console.log('Fetch response status:', response.status);

            const data = await response.json();

            if (response.ok) {
                console.log('Order updated successfully', data);
            } else {
                console.error('Failed to update order:', data.message);
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    }

    const totalItemsElement = document.querySelector('.breadcrumb .total-items');

    if (totalItemsElement) {
        const folderItemsCount = foldersGrid ? foldersGrid.querySelectorAll('.item').length : 0;
        const fileItemsCount = filesGrid ? parseInt(filesGrid.getAttribute('data-total-items'), 10) : 0;
        const totalItems = folderItemsCount + fileItemsCount;

        if (totalItems > 0) {
            totalItemsElement.classList.remove('hidden');
            const totalCountElement = totalItemsElement.querySelector('.count');
            if (totalCountElement) {
                totalCountElement.textContent = totalItems.toLocaleString();
            }
        }
    }

    const reloadBrokenImages = () => {
        const images = document.querySelectorAll('.selectable.artworks-list img');
        images.forEach(img => {
            if (!img.complete || img.naturalWidth === 0) {
                // Reload the image
                const src = img.src;
                img.src = ''; // Clear the source
                img.src = src; // Set it back to trigger a reload
            }
        });

        // Display a toast message
        UIUtils.toast('success', 'Reloading broken images');
    };

    document.addEventListener('keydown', event => {
        if ((event.key === 'r' || event.key === 'R') && event.ctrlKey) {
            event.preventDefault(); // Prevent the default action for Ctrl+R
            reloadBrokenImages(); // Call your function to reload broken images
        }
    });

    // Add event listener for toggling published state
    const pageListGrid = document.querySelector('[data-type="page-list"]');
    if (pageListGrid) {
        pageListGrid.addEventListener('click', async (event) => {
            const toggleButton = event.target.closest('.state .badge.toggle');
            if (toggleButton) {
                const row = toggleButton.closest('tr');
                const pageId = row.dataset.id;

                try {
                    const response = await fetch(`/api/pages/toggle-published/${pageId}`, {
                        method: 'POST'
                    });

                    if (response.ok) {
                        const data = await response.json();
                        if (data.isPublished) {
                            toggleButton.classList.replace('dark:bg-gray-500', 'green');
                            toggleButton.textContent = 'Published';
                        } else {
                            toggleButton.classList.replace('green', 'dark:bg-gray-500');
                            toggleButton.textContent = 'Inactive';
                        }
                    } else {
                        console.error('Failed to toggle published state:', response.statusText);
                    }
                } catch (error) {
                    console.error('Error toggling published state:', error);
                }
            }
        });
    }

}